export const defaultEnterprise = {
  data: [
    {
      entId: 'ent-ntt-managed-service',
      entName: 'NTT Managed Service',
      createdAt: '2026-06-01T02:30:00Z',
      entRoleId: 1,
      entRoleName: 'Super Admin',
      orgNum: 2,
      siteNum: 3,
      cameraNum: { online: 38, offline: 3, onboarding: 1 },
      nvrNum: { online: 4, offline: 0, onboarding: 0 },
      adoptedDeviceNum: { ap: 42, switch: 18 },
      inventoryDeviceNum: { ap: 6, switch: 4 },
      clientNum: { wired: 112, wireless: 200 },
      alertNum: { critical: 3, normal: 18, low: 42 },
    },
    {
      entId: 'ent-global-network-services',
      entName: 'Global Network Services',
      createdAt: '2026-06-18T08:00:00Z',
      entRoleId: 2,
      entRoleName: 'Admin',
      orgNum: 1,
      siteNum: 0,
      cameraNum: { online: 7, offline: 1, onboarding: 0 },
      nvrNum: { online: 1, offline: 0, onboarding: 0 },
      adoptedDeviceNum: { ap: 8, switch: 4 },
      inventoryDeviceNum: { ap: 1, switch: 2 },
      clientNum: { wired: 24, wireless: 40 },
      alertNum: { critical: 0, normal: 2, low: 6 },
    },
  ],
};

export const defaultStandaloneOrg = {
  data: [
    {
      orgId: 'org-dlink-headquarters',
      orgName: 'D-Link Headquarters',
      createdAt: '2026-07-04T03:15:00Z',
      orgRoleId: 5,
      orgRoleName: 'Admin',
      orgNum: 1,
      siteNum: 2,
      cameraNum: { online: 15, offline: 2, onboarding: 0 },
      nvrNum: { online: 2, offline: 0, onboarding: 0 },
      adoptedDeviceNum: { ap: 17, switch: 6 },
      inventoryDeviceNum: { ap: 3, switch: 1 },
      clientNum: { wired: 46, wireless: 100 },
      alertNum: { critical: 1, normal: 9, low: 18 },
    },
  ],
};

export const defaultManageOrg = {
  data: {
    orgs:[
      {
        orgId: 'org-taiwan-operations',
        orgName: 'Taiwan Operations',
        orgRoleId: 5,
        orgRoleName: 'Admin',
        country: 'Taiwan',
        timeZone: 'Asia/Taipei',
        ntpServers: ['ntp1.nuclias.com', 'time.google.com'],
        inventoryDeviceAccount: { username: 'admin', password: 'MockPassword!288' },
        siteNum: 2,
        adoptedDeviceNum: { ap: 30, switch: 10 },
        clientNum: { wired: 16, wireless: 200 },
        alertNum: { critical: 2, normal: 10, low: 21 },
        createdAt: '2026-06-02T03:30:00Z',
      },
      {
        orgId: 'org-japan-operations',
        orgName: 'Japan Operations',
        orgRoleId: 6,
        orgRoleName: 'Viewer',
        country: 'Japan',
        timeZone: 'Asia/Tokyo',
        ntpServers: ['ntp1.nuclias.com'],
        inventoryDeviceAccount: { username: 'admin', password: 'MockPassword!288' },
        siteNum: 1,
        adoptedDeviceNum: { ap: 4, switch: 2 },
        clientNum: { wired: 14, wireless: 40 },
        alertNum: { critical: 1, normal: 2, low: 4 },
        createdAt: '2026-06-10T01:00:00Z',
      },
    ],
  },
};

export const defaultOrganizationsByEnterprise = {
  'ent-ntt-managed-service': defaultManageOrg,
  'ent-global-network-services': {
    data: {
      orgs: [
        {
          orgId: 'org-global-services',
          orgName: 'Global Services',
          orgRoleId: 5,
          orgRoleName: 'Admin',
          country: 'United States',
          timeZone: 'America/New_York',
          ntpServers: ['time.google.com'],
          inventoryDeviceAccount: { username: 'admin', password: 'MockPassword!288' },
          siteNum: 0,
          adoptedDeviceNum: { ap: 8, switch: 4 },
          clientNum: { wired: 24, wireless: 40 },
          alertNum: { critical: 0, normal: 2, low: 6 },
          createdAt: '2026-06-18T08:00:00Z',
        },
      ],
    },
  },
};

export const defaultSite = {
  data: {
    sites:[
      {
        siteId: 'site-taipei-hq',
        siteName: 'Taipei Headquarters',
        siteRoleId: 9,
        siteRoleName: 'Admin',
        country: 'Taiwan',
        timeZone: 'Asia/Taipei',
        ntpServers: ['ntp1.nuclias.com'],
        address: 'No. 289, Xinhu 3rd Road, Neihu District, Taipei City',
        applyAddressToManagedDevices: true,
        deviceAccount: { username: 'admin', password: 'MockPassword!288' },
        apNum: { online: 24, offline: 1, onboarding: 1 },
        switchNum: { online: 8, offline: 0, onboarding: 0 },
        routerNum: { online: 2, offline: 0, onboarding: 0 },
        clientNum: { wireless: 182, wired: 34 },
        alertNum: { critical: 2, normal: 9, low: 18 },
        createdAt: '2026-06-03T05:00:00Z',
        cloneConfiguration: {
          generalSettings: true,
          wirelessNetworks: ['Corp-WiFi', 'Guest'],
          wiredBasicConfig: true,
          captivePortalProfiles: 2,
          portProfiles: 2,
          macGroups: 1,
          radiusProfiles: 1,
          notificationSettings: true,
          serviceSubscriptions: ['NMS Pro'],
        },
      },
      {
        siteId: 'site-taichung-warehouse',
        siteName: 'Taichung Warehouse',
        siteRoleId: 9,
        siteRoleName: 'Admin',
        country: 'Taiwan',
        timeZone: 'Asia/Taipei',
        ntpServers: ['ntp1.nuclias.com'],
        address: 'Taichung Harbor District',
        applyAddressToManagedDevices: false,
        deviceAccount: { username: 'admin', password: 'MockPassword!288' },
        apNum: { online: 6, offline: 0, onboarding: 0 },
        switchNum: { online: 2, offline: 0, onboarding: 0 },
        routerNum: { online: 0, offline: 0, onboarding: 0 },
        clientNum: { wireless: 31, wired: 8 },
        alertNum: { critical: 0, normal: 1, low: 3 },
        createdAt: '2026-06-08T05:00:00Z',
        cloneConfiguration: {
          generalSettings: true,
          wirelessNetworks: ['Warehouse'],
          wiredBasicConfig: true,
          captivePortalProfiles: 0,
          portProfiles: 1,
          macGroups: 0,
          radiusProfiles: 0,
          notificationSettings: true,
          serviceSubscriptions: ['NMS Pro'],
        },
      },
    ],
  },
};

const createSiteCollection = (sites) => ({ data: { sites } });

export const defaultSitesByOrganization = {
  'org-taiwan-operations': createSiteCollection([...defaultSite.data.sites]),
  'org-dlink-headquarters': createSiteCollection([...defaultSite.data.sites]),
  'org-japan-operations': createSiteCollection([
    {
      siteId: 'site-tokyo-office',
      siteName: 'Tokyo Office',
      siteRoleId: 9,
      siteRoleName: 'Admin',
      country: 'Japan',
      timeZone: 'Asia/Tokyo',
      ntpServers: ['ntp1.nuclias.com'],
      address: 'Chiyoda City, Tokyo',
      applyAddressToManagedDevices: true,
      deviceAccount: { username: 'admin', password: 'MockPassword!288' },
      apNum: { online: 4, offline: 0, onboarding: 0 },
      switchNum: { online: 2, offline: 0, onboarding: 0 },
      routerNum: { online: 1, offline: 0, onboarding: 0 },
      clientNum: { wireless: 42, wired: 12 },
      alertNum: { critical: 1, normal: 2, low: 4 },
      createdAt: '2026-06-10T01:00:00Z',
    },
  ]),
  'org-global-services': createSiteCollection([]),
};

export const defaultCloneJob = {
  data: {
    id: 'clone-job-site-taipei-hq-copy',
    status: 'in_progress',
    sourceSiteId: 'site-taipei-hq',
    targetOrganizationId: 'org-taiwan-operations',
    newSiteName: 'Taipei Headquarters - Copy',
    createdSiteId: null,
    progress: 65,
    message: 'Creating Taipei Headquarters - Copy and applying cloned configurations',
    createdAt: '2026-08-01T03:00:00Z',
    completedAt: null,
  },
};
